// Simple initialization manager to prevent duplicate calls
const initializationStates = new Map();
const initializationPromises = new Map();

export const createInitializationManager = (key) => {
  return {
    isInitialized: () => initializationStates.get(key) || false,

    setInitialized: (value = true) => {
      initializationStates.set(key, value);
    },

    getOrCreatePromise: (initFunction) => {
      if (initializationStates.get(key)) {
        return Promise.resolve();
      }

      if (initializationPromises.has(key)) {
        return initializationPromises.get(key);
      }

      const promise = initFunction().finally(() => {
        initializationPromises.delete(key);
      });

      initializationPromises.set(key, promise);
      return promise;
    },

    reset: () => {
      initializationStates.delete(key);
      initializationPromises.delete(key);
    },
  };
};
